/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Stat_NotesInputs */

const en_landing_preview_stat_notes = /** @type {(inputs: Landing_Preview_Stat_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes indexed`)
};

/**
* | output |
* | --- |
* | "Notes indexed" |
*
* @param {Landing_Preview_Stat_NotesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_stat_notes = /** @type {((inputs?: Landing_Preview_Stat_NotesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Stat_NotesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_stat_notes(inputs)
});